import _ from 'lodash';
import Vue from 'vue';
import Gravatar from 'vue-gravatar';
import moment from 'moment';
import AsyncComputed from 'vue-async-computed';
import Vue2Filters from 'vue2-filters';
import mask from 'vue-the-mask';
import VueTimeago from 'vue-timeago';
// import fr from 'date-fns/locale/fr';
import en from 'date-fns/locale/en';
import { dateFilter } from 'vue-date-fns';
import '@babel/polyfill';
import vueFeathers from 'vue-feathers';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './directives';
import './components';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';

/** Add/replace client's components */
import './_komacut/components';
import feathersClient from './feathers-client';

window._ = _;
window.moment = moment;

Vue.config.productionTip = false;

// Make sure lodash works in templates too
Vue.prototype._ = _;
Vue.prototype.moment = moment;

Vue.component('v-gravatar', Gravatar);
Vue.use(AsyncComputed);
Vue.use(Vue2Filters);
Vue.use(mask);
Vue.use(VueTimeago, {
  locale: i18n.locale,
  locales: {
    // fr,
    en,
  },
});
Vue.use(vueFeathers, feathersClient);

moment.locale(i18n.locale);

Vue.filter('date', dateFilter);

new Vue({
  router,
  i18n,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
